import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: left;
  width: 870px;
  height: 100%;
  padding-left: 40px;
  padding-top: 20px;
  box-sizing: border-box;
  @media (max-width: 1400px) {
    width: 435px;
    & > * {
      &:nth-child(1) {
        margin-right: 180px;
      }
    }
  }
`;
